<template>
  <v-layout row wrap>
    <v-flex v-if="mostrarDS == 1">
      <v-widget
        class="px-0"
        :title="titulo"
        :key="indexChart"
        content-bg="white"
      >
        <div slot="widget-content">
          <e-chart
            :path-option="[
              ['dataset.source', res],
              ['legend.bottom', '0'],
              [
                'color',
                [color.lightBlue.base, color.orange.base, color.grey.base],
              ],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie'],
              ['series[0].name', 'ds'],
              ['series[0].avoidLabelOverlap', true],
              ['series[0].radius', ['50%', '70%']],
            ]"
            height="400px"
            width="100%"
          >
          </e-chart>
        </div>
      </v-widget>
    </v-flex>
  </v-layout>
</template>
<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grafica-ds",

  props: {
    periodo: "",
    proveedor: "",
  },

  components: {
    VWidget,
    EChart,
    CircleStatistic,
  },

  mixins: [misMixins],
  data: () => ({
    color: Material,
    indexChart: 0,
    res: [],
    titleGrafica: [],
    titleTest: [],
    pruebas: [],
    titulo: "",
    mostrarDS: 0,
  }),

  computed: {},

  created() {
    this.id = this.$route.params.id;
    this.loadDataDs();
  },

  methods: {
    async loadDataDs() {
      this.mostrarDS = 0;

      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadDs();
      if (this.pruebas.length > 0) {
        this.mostrarDS = 1;

        this.pruebas.forEach((m) => {
          let aprobados = m.aprobados;
          this.titulo = "Personal - DS";
          let data = [];

          data.push(
            {
              value: m.aprobados.toFixed(2),
              name: "Aprobados",
            },
            {
              value: m.reprobados.toFixed(2),
              name: "Reprobados",
            },
            {
              value: m.porcen_otros.toFixed(2),
              name: "Otros",
            }
          );

          this.res = data;
          this.indexChart += 1;
        });
      } else {
        this.mostrarDS = 0;
        //this.showAlert=true;
      }
      this.loading = false;
    },
    async loadDs() {
      //alert("Personal - DS: periodo");

      if (this.periodo != null && this.proveedor != null) {
        return await axios
          .get(
            "/reportes/personal/dsProv/" + this.periodo + "/" + this.proveedor
          )
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //alert("sin dato DS");
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        return await axios
          .get("/reportes/personal/ds/" + this.periodo)
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //alert("sin dato DS");
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },
  },
};
</script>
